import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DeviceDelink from './DeviceDelink';
import {
  fetchUserDevices,
  deactivateUserDevice,
} from 'services/redux/deviceDelink/action';

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserDevices,
      deactivateUserDevice,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(DeviceDelink);
